import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import {useLocation} from "react-router-dom";
import PropTypes from "prop-types";
import withRouter from "../Components/Common/withRouter";

//import Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../Components/Common/RightSidebar";
import FooterText from "./FooterText";
import Loader from '../Components/Common/Loader';
//import actions
import {
  changeLayout,
  changeSidebarTheme,
  changeLayoutMode,
  changeLayoutWidth,
  changeLayoutPosition,
  changeTopbarTheme,
  changeLeftsidebarSizeType,
  changeLeftsidebarViewType,
  changeSidebarImageType,
} from "../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

// actions
import { getGenerateKeyApi, getEncryptKeyApi } from "../helpers/fakebackend_helper";

const Layout1 = (props) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const {
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
  } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    leftSidebarType: state.Layout.leftSidebarType,
    layoutModeType: state.Layout.layoutModeType,
    layoutWidthType: state.Layout.layoutWidthType,
    layoutPositionType: state.Layout.layoutPositionType,
    topbarThemeType: state.Layout.topbarThemeType,
    leftsidbarSizeType: state.Layout.leftsidbarSizeType,
    leftSidebarViewType: state.Layout.leftSidebarViewType,
    leftSidebarImageType: state.Layout.leftSidebarImageType,
  }));

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType
    ) {
      dispatch(changeLeftsidebarViewType(leftSidebarViewType));
      dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
      dispatch(changeSidebarTheme(leftSidebarType));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeLayoutWidth(layoutWidthType));
      dispatch(changeLayoutPosition(layoutPositionType));
      dispatch(changeTopbarTheme(topbarThemeType));
      dispatch(changeLayout(layoutType));
      dispatch(changeSidebarImageType(leftSidebarImageType));
    }
  }, [
    layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    dispatch,
  ]);
  const { generatedKey } = useSelector((state) => ({
    generatedKey: state.GenerateKey.generatedKey,
  }));
  const { encryptKey } = useSelector((state) => ({
    encryptKey: state.EncryptKey.encryptKey,
  }));

  const client_code  = localStorage.getItem('client_id');
  const client_token = localStorage.getItem('client_token');


  // const search = useLocation().search;
  // const client_id = new URLSearchParams(search).get('client_id');
  // const token = new URLSearchParams(search).get('token');

  // let decodedStringAtoB = atob(client_id);
  // let decodedStringAtoc = atob(token);
  // localStorage.setItem('client_id', decodedStringAtoB);
  // localStorage.setItem('client_token', decodedStringAtoc);

  /*
  get data
  */
  useEffect(() => {
    getGenerateKeyApi().then((response) => {
      ////console.log(response);
    localStorage.setItem('genApiKeyResult', JSON.stringify(response.genApiKeyResult));
      
    })
    .catch((err) => {
      ////console.log(err);
    });
  }, [dispatch, client_code]);

    
    useEffect(()=>{
      if(client_code){
        // const encryptedClientId = Encryptclcode(client_code);
        // localStorage.setItem('encryptKey', (JSON.stringify(encryptedClientId)));
        setLoading(false)
      }
     
     },[client_code])
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };

  const [headerClass, setHeaderClass] = useState("");
  // class add remove in header
  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });
  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  return (
    <React.Fragment>
      <div>
        <Header
          headerClass={headerClass}
          layoutModeType={layoutModeType}
          onChangeLayoutMode={onChangeLayoutMode}
        />
        <Sidebar layoutType={layoutType} />
          {loading ? <Loader /> : props.children}
      </div>
    </React.Fragment>
  );
};

Layout1.propTypes = {
  children: PropTypes.object,
};

export default withRouter(Layout1);
